export default __webpack_public_path__ + "static/media/add-team-user.c537e0af.svg";